// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__U3Z5B","modalForm":"UpgradeEpcsModal_modalForm__1DaV4","modalFooter":"UpgradeEpcsModal_modalFooter__3wCAn"};